import React, { useEffect, useState, useCallback, Fragment } from 'react';
import PropTypes from 'prop-types';
import BackToTopAnthor from '../components/BackToTopAnthor';
import TitleAnchor from '../components/TitleAnchor';

function WidgetContainer({ translate }) {
  const [showTitleAnchor, setShowTitleAnchor] = useState(false);
  const [showBackToTop, setShowBackToTop] = useState(false);

  const handleScroll = useCallback(() => {
    const { scrollY: scrollPosition } = window;
    if (scrollPosition > 500 && scrollPosition < 2800) {
      if (!showTitleAnchor) {
        setShowTitleAnchor(true);
      }
    } else if (showTitleAnchor) {
      setShowTitleAnchor(false);
    }

    if (scrollPosition > 500) {
      if (!showBackToTop) {
        setShowBackToTop(true);
      }
    } else if (showBackToTop) {
      setShowBackToTop(false);
    }
  }, [showBackToTop, showTitleAnchor]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  return (
    <Fragment>
      <TitleAnchor translate={translate} isShown={showTitleAnchor} />
      {showBackToTop && <BackToTopAnthor />}
    </Fragment>
  );
}

WidgetContainer.propTypes = {
  translate: PropTypes.func.isRequired
};

export default WidgetContainer;
